import { useState } from 'react';
import { truncateString, stringLengthMax } from '../../utils/utilFunctions';

import StyledWrapper from './style';

import Tooltip from '@mui/material/Tooltip';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import SubmissionStageIcon from '../../assets/customIcons/submissionStageIcon';
import ReviewStageIcon from '../../assets/customIcons/reviewStageIcon.jsx';
import { getStatusColor } from '../../utils/utilFunctions';
import VerticalNavLink from './VerticalNavLink';
import ReviewsDropdown from './ReviewsDropdown';

const FormsDropdown = ({
	item,
	active,
	text,
	onClick,
	isStage,
	lastChild,
	status,
	currentStage
}) => {
	const [expanded, setExpanded] = useState(true);
	const url = window.location.href;
	const isActive = item?.stage_id === active || url.includes(`${item?.stage_id}/details`);

	return (
		<StyledWrapper.DropdownContainer
			expanded={expanded}
			TransitionProps={{ unmountOnExit: true }}
			lastChild={lastChild}
			id={'second-dropdownContainer'}
			active={isActive}
		>
			<AccordionSummary
				aria-controls={`${text}-content`}
				id={`${text}-header`}
				sx={{
					minHeight: '24px!important',
					paddingBottom: expanded && '10px!important'
				}}
			>
				{expanded ? (
					<StyledWrapper.MinusIcon
						onClick={() => {
							setExpanded(false);
						}}
					/>
				) : (
					<StyledWrapper.PlusIcon
						onClick={() => {
							setExpanded(true);
						}}
					/>
				)}
				{item?.stage_id?.toLowerCase().includes('ssi-') ? (
					<SubmissionStageIcon
						isActive={true}
						customColor={getStatusColor(status)}
						isCurrentStage={currentStage}
					/>
				) : (
					<ReviewStageIcon
						isActive={true}
						customColor={getStatusColor(status)}
						isCurrentStage={currentStage}
					/>
				)}
				<Tooltip title={text.length > stringLengthMax ? text : ''} arrow placement="top">
					<StyledWrapper.NavLink
						onClick={() => onClick(item?.link || item?.stage_id)}
						active={isActive}
					>
						{truncateString(text)}
					</StyledWrapper.NavLink>
				</Tooltip>
			</AccordionSummary>

			<AccordionDetails
				className={`${isStage && !lastChild && 'isStage'}`}
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: '5px',
					marginLeft: item?.stage_id?.includes('esi-') ? '20px' : '52px;'
				}}
			>
				{item?.forms?.map((e, index) => (
					<>
						{!e?.review ? (
							<VerticalNavLink
								status={e?.status}
								currentStage={e?.is_current_stage}
								key={`${index}-${e?.title}`}
								isForm={true}
								isReviewForm={e?.id.toLowerCase().includes('rfm-')}
								isChild={true}
								lastChild={item?.forms?.length - 1 === index}
								active={url.includes(`${e?.id}`) || active === e?.id}
								text={e?.title}
								onClick={() => onClick(e?.link || e?.id)}
								external={false}
							/>
						) : (
							<ReviewsDropdown
								status={e?.status}
								key={`${index}-${e?.title}`}
								isForm={false}
								isChild={true}
								lastChild={item?.forms?.length - 1 === index}
								item={e?.review}
								active={active}
								text={e?.title}
								formId={e?.id}
								masterLink={e?.link || e?.id}
								onClick={(x) => onClick(x)}
							/>
						)}
					</>
				))}
			</AccordionDetails>
		</StyledWrapper.DropdownContainer>
	);
};

export default FormsDropdown;
